import React from 'react';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import updateCandidateInformation from 'api/updateCandidateInformation';

class EditorCandidateInfoModal extends React.Component {
	constructor(props) {
		super(props);

		// Safely extract testUser from selectedTestUser array
		const [{testUser = null, key = null} = {}] =
			this.props.selectedTestUser || [];

		this.state = {
			testUserDetails: testUser,
			testKey: key,
			editedJson: JSON.stringify(testUser, null, 2), // pretty JSON
			jsonError: false,
			showAlert: false,
			success: null,
			message: '',
			isConfirmedDisabled: false,
		};
	}

	// Handle JSON textarea edits
	onJsonChange = (e) => {
		const value = e.target.value;

		try {
			JSON.parse(value);
			this.setState({editedJson: value, jsonError: false});
		} catch {
			this.setState({editedJson: value, jsonError: true});
		}
	};

	// Save the updated JSON
	onConfirm = () => {
		const {editedJson, jsonError} = this.state;

		if (jsonError) return; // do not submit invalid JSON

		let candidateInformationObject;

		try {
			candidateInformationObject = JSON.parse(editedJson);
		} catch {
			this.setState({
				jsonError: true,
				showAlert: true,
				success: false,
				message: strings.invalidJson,
			});
			return;
		}

		this.setState({isConfirmedDisabled: true});

		updateCandidateInformation({
			info: candidateInformationObject,
			testKey: this.state.testKey,
		}).then((res) => {
			if (!res) {
				this.setState({
					showAlert: true,
					success: false,
					message: strings.opsSomethingWentWrong,
				});
			} else {
				this.props.getTestsBySearch({testKey: this.state.testKey});
				this.setState({
					showAlert: true,
					success: true,
					message: strings.candidateInfoUpdatedSuccessfully,
				});
			}

			setTimeout(() => {
				this.setState({showAlert: false});
				this.props.onEditModelConfirm();
			}, 3000);
		});
	};

	// Cancel editing
	onCancel = () => {
		this.props.onEditModelCancel();
		this.setState({
			error: null,
			success: null,
			message: '',
		});
	};

	render() {
		const {editedJson, jsonError, showAlert, message, success} = this.state;

		return (
			<div>
				<div>
					<h3>{strings.editCandidateInformation}</h3>
				</div>

				{/* JSON Editor */}
				<textarea
					style={{
						width: '100%',
						height: '300px',
						fontFamily: 'monospace',
						fontSize: '14px',
						padding: '10px',
						borderRadius: '8px',
						border: jsonError ? '2px solid red' : '1px solid #ccc',
						background: '#fafafa',
						whiteSpace: 'pre',
					}}
					value={editedJson}
					onChange={this.onJsonChange}
				/>

				{jsonError && (
					<p style={{color: 'red', marginTop: '5px'}}>
						{strings.invalidJsonFormat}
					</p>
				)}

				<div className="lit-post-notification-btn-div">
					<button
						className="lit-btn bg-primary"
						disabled={jsonError}
						onClick={this.onConfirm}
					>
						{strings.confirm}
					</button>

					<button
						className="lit-btn bg-negative"
						onClick={this.onCancel}
					>
						{strings.cancel}
					</button>
				</div>

				{showAlert && (
					<AlertBox
						type={success ? 'success' : 'error'}
						message={message}
					/>
				)}
			</div>
		);
	}
}

export default EditorCandidateInfoModal;
